module.exports = __webpack_public_path__ + "static/media/cnito_logo.0f54d4b1.gif";